import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "../ui/button";

const CTA = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="relative bg-gradient-to-br from-orange-600 via-red-600 to-amber-600 rounded-3xl overflow-hidden shadow-2xl">
          {/* Decorative */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-400/20 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-red-800/20 rounded-full translate-y-1/2 -translate-x-1/2" />

          <div className="relative z-10 p-10 md:p-16 text-center text-white">
            <p className="font-devanagari text-2xl md:text-3xl text-yellow-200 mb-3">आपके बच्चे का भविष्य यहाँ से शुरू</p>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Give Your Child the Best Start
            </h2>
            <p className="text-orange-50 max-w-xl mx-auto mb-8 text-lg">
              Admissions are open for early registration. Book a virtual info session and secure priority admission for our 1st January 2027 launch.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/admission">
                <Button size="lg" className="bg-white text-orange-700 hover:bg-yellow-100 rounded-full px-8 h-12 shadow-lg font-bold">
                  Apply Now <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
              <a href="tel:+917617755821">
                <Button size="lg" variant="outline" className="bg-transparent border-2 border-white text-white hover:bg-white/10 rounded-full px-8 h-12">
                  <Phone className="mr-2 w-4 h-4" /> Call Now
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
